module.exports = __webpack_public_path__ + "static/media/0.2f97b172.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/0.png
// module id = 748
// module chunks = 0